let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("4UPrd"), load("hlVat")]).then(() => parcelRequire('3ssyD'));